import React, { forwardRef, useCallback, useImperativeHandle, useState } from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'
import clsx from 'clsx'
import Dialog from '../../../molecules/Dialog/Dialog'
import RoundedButton from '../../../atoms/RoundedButton'
import { useClientDetails } from './ClientDetailsFormContext'

const useStyles = makeStyles((theme) => ({
  button: {
    borderRadius: 'var(--border-radius-round)',
    fontWeight: 800,
    textTransform: 'capitalize',
    padding: '14px 16px',
    width: '280px',
    marginRight: '10px',
    boxShadow: 'none',
    '&:hover': {
      boxShadow: 'none'
    }
  },
  cancelBtn: {
    backgroundColor: 'var(--theme-color-surface-d0)',
    color: 'var(--color-danger-500)',
    '&:hover': {
      backgroundColor: '#f3b3be'
    }
  },
  confirmBtn: {
    backgroundColor: 'var(--color-neutral-400)',
    color: 'var(--text-color-main)',
    '&:hover': {
      backgroundColor: 'var(--color-neutral-600)'
    }
  }
}))

const DeleteDialog = forwardRef(function DeleteDialog ({ onConfirm }, ref) {
  const classes = useStyles()
  const { client } = useClientDetails()
  const [open, setOpen] = useState(false)
  const handleConfirm = useCallback(async () => {
    await onConfirm()
    setOpen(false)
  }, [setOpen, onConfirm])

  useImperativeHandle(ref, () => {
    return {
      open: () => setOpen(true),
      close: () => setOpen(false)
    }
  }, [setOpen])

  return (
    <Dialog open={open} onClose={() => setOpen(false)}>
      <Dialog.Header>
        FULL CLIENT DELETE - Are you sure you want to delete {client?.longName}?
      </Dialog.Header>
      <Dialog.Actions>
        <RoundedButton onClick={() => setOpen(false)} className={clsx(classes.button, classes.cancelBtn)}>
          Cancel
        </RoundedButton>
        <RoundedButton onClick={handleConfirm} className={clsx(classes.button, classes.confirmBtn)}>
          Delete
        </RoundedButton>
      </Dialog.Actions>
    </Dialog>
  )
})

DeleteDialog.propTypes = {
  onConfirm: PropTypes.func
}

export default DeleteDialog
